import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "wrapper-deliveries" }
const _hoisted_3 = { class: "above-table" }
const _hoisted_4 = { class: "wrapper-table" }
const _hoisted_5 = { class: "table-users" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDeliveryDetails = _resolveComponent("ModalDeliveryDetails")!
  const _component_Title = _resolveComponent("Title")!
  const _component_Searcher = _resolveComponent("Searcher")!
  const _component_StandardButton = _resolveComponent("StandardButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_ModalDeliveryDetails, {
      onClose: _ctx.hideSelectedDeliveryDetails,
      delivery: _ctx.deliverySelected
    }, null, 8, ["onClose", "delivery"]), [
      [_vShow, _ctx.showModalDeliveryDetail]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Title, { title: "Entregas" }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Searcher, {
            search: _ctx.query,
            "onUpdate:search": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event))
          }, null, 8, ["search"]),
          _createVNode(_component_StandardButton, {
            buttonLabel: 'Crear entrega',
            onClick: _ctx.goToDeliveryOption
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Fecha de creación"),
                _createElementVNode("th", null, "Nombre"),
                _createElementVNode("th", null, "Cliente"),
                _createElementVNode("th", null, "Detalles"),
                _createElementVNode("th", null, "Reenviar correo"),
                _createElementVNode("th", null, "Obtener link")
              ])
            ], -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDeliveries, (delivery, index) => {
              return (_openBlock(), _createElementBlock("tbody", { key: index }, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, _toDisplayString(delivery.deliveryDate), 1),
                  _createElementVNode("td", null, _toDisplayString(delivery.name), 1),
                  _createElementVNode("td", null, _toDisplayString(delivery.client), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("img", {
                      src: "assets/administrator/Details.svg",
                      alt: "details",
                      class: "icon-table",
                      onClick: ($event: any) => (_ctx.getDetailsTransaction(delivery))
                    }, null, 8, _hoisted_6)
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("td", null, [
                    _createElementVNode("img", {
                      src: "assets/administrator/Email.svg",
                      alt: "email",
                      class: "icon-table"
                    })
                  ], -1)),
                  _cache[2] || (_cache[2] = _createElementVNode("td", null, [
                    _createElementVNode("img", {
                      src: "assets/administrator/Link.svg",
                      alt: "link",
                      class: "icon-table"
                    })
                  ], -1))
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 64))
}